module.exports = __webpack_public_path__ + "img/5_1.39cd0a67.png";